import { render, staticRenderFns } from "./AddSectionCost.vue?vue&type=template&id=b6334216&scoped=true&"
import script from "./AddSectionCost.vue?vue&type=script&lang=js&"
export * from "./AddSectionCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6334216",
  null
  
)

export default component.exports